import React from 'react';
import Link from 'next/link';
import { MenuItem } from '@material-ui/core';
import { defaultPhoneNumber } from '../../utils/commonUtils';

interface TelContactProps {
  topHeaderItem: string;
  topHeaderItemLink: string;
}

const TelContact: React.FC<TelContactProps> = ({topHeaderItem, topHeaderItemLink}) => {
  const toLinkTelephoneNumber = `tel:${defaultPhoneNumber}`;
  return (
    <MenuItem className={topHeaderItem}>
      <Link href={toLinkTelephoneNumber}>
        <a className={topHeaderItemLink}>{defaultPhoneNumber}</a>
      </Link>
    </MenuItem>
  );
};

export default TelContact;
